import CategoryInfo from '../schema/CategoryInfo';
import { CalendarEvent } from 'mini-calendar-event-types';
import { CategoryMetadata } from '../schema/CategoryMetadata';
import { getCategoriesStore } from '../store/store';

/**
 * Function which returns a lookup of information related to categories of an event
 * @param event
 */
export const getCategoriesInfoForEvent = (event: CalendarEvent): CategoryInfo =>
    event?.Categories?.reduce(
        ([categoryInfo, lookup]: [{}, Map<string, CategoryMetadata>], category) => {
            categoryInfo[category] = lookup.get(category);
            return [categoryInfo, lookup];
        },
        [{}, getCategoriesStore().categoriesLookup]
    )?.[0] || {};
